import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { ShipmentDestinationService } from './shipment-destination.service';

interface Container {
  store_number: string;
  manifest_id: string;
  // ... other properties ...
}

@Component({
  selector: 'app-shipment-order-creator',
  templateUrl: './shipment-order-creator.component.html',
  styleUrls: ['./shipment-order-creator.component.scss']
})
export class ShipmentOrderCreatorComponent implements OnInit {

  isReconcilingAddress = false;
  addressReconcileMessage = '';
  addressReconcileError = false;

  step = 1
  totalSteps = 3

  // initialize forms for the wizard
  contactForm!: FormGroup
  loadDetailsForm!: FormGroup
  appointmentForm!: FormGroup
  deliveryLoad02Form!: FormGroup
  deliveryLoad03Form!: FormGroup
  creationError = "";
  pendingCreationRequest: any = null;
  private shipperBeforeIntermodal: Record<string, unknown> | null = null;
  addIntermodalLeg: boolean = false

  shipment_list_uuid: string = ''
  store_number: string = ''
  pro_bill: string = ''
  appointment_day_of_the_week: string = ''
  shipment_details: any = this.emptyShipmentDetails()
  pallets: any[] = []
  containers: any[] = []
  load_02: boolean = false
  load_03: boolean = false

  // default column definitions
  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: true
  };

  // boolean to display the wizard after the API has completed retrieving data
  showContent: boolean = false

  // initialize arrays for mat selection dropdowns
  typeListShipper = {
    "90a8a818-1107-4f16-9609-b0c7d06d9eac": "THE FBI GROUP (SPIRIT)",
    "e598ef72-7c41-41bc-920f-9a7d94e16ba7": "SPENCER GIFTS C/O THE FBI GROUP",
    "abd4daf1-3544-4b0e-8730-831ae92844f0": "THE FBI GROUP C/O STRYDER (SITE FB2)",
    "2c15c45e-8f88-494a-8752-c2bd7281a094": "STRYDER - VBC",
    "fcb24475-d4c4-4f49-9532-933704298976": "CONSOLIDATED FASTFRATE INC. (CALGARY)",
    "9fc6f259-3434-4ca0-acd2-b3a1194e8072": "CONSOLIDATED FASTFRATE INC. (EDMONTON)",
    "ab1f86a3-07ec-4c10-9525-3ed34c7cf5eb": "CONSOLIDATED FASTFRATE INC. (VANCOUVER)",
    "34057143-bdc8-4a7b-bf6f-79fc53ae4318": "CONSOLIDATED FASTFRATE INC (WINNIPEG)",
    "4a8b8b58-f5ff-4a8d-a408-9c3cbbdc5c7c": "SG DISTRIBUTION CENTER (Pineville)",
    "a980a12f-743e-419c-8e3c-676e64305a47": "NFI (Chino)",
    "10865029-e760-477a-bc14-94b9328f079d": "NFI - ONTARIO SITE",
    "e420767d-7549-4e52-a2fe-5d0036413dfc": "NFI - FREDERICKSBURG",    
    "d9b23c14-069a-4eb6-972f-8ff9c498bb20": "GAP CANADA (SITE GA7)",     
    "8f83895e-f813-4d7e-b03d-904508e3e3ad": "WAINRIGHT TRUCKING LIMITED",
    "e0cabf6c-746f-403a-9af8-d5dfd630d8a5": "DSR - DELTA",
    "4523aeef-6e85-4d0d-b221-44b4ccdddcb8": "DSR Terminal",
    "0d40741d-eabb-449c-b047-80df502dc900": "GVN TRANSPORT LTD",
    "817009ae-a00e-4a83-b38b-62767abe4a1d": "WINNIPEG CROSSDOCK & LOGISTICS INC",    
    "13e96812-85cf-46df-8562-69f2eb4b39ee": "LEO GREEN LOGISTIC"
  }

  typeListConsigneeLeg = [
    'THE FBI GROUP C/O STRYDER (SITE FB2)',
    'STRYDER - VBC',
    "CONSOLIDATED FASTFRATE INC. (CALGARY)",
    "CONSOLIDATED FASTFRATE INC. (EDMONTON)",
    "CONSOLIDATED FASTFRATE INC. (VANCOUVER)",
    "CONSOLIDATED FASTFRATE INC (WINNIPEG)",
    'SG DISTRIBUTION CENTER (Pineville)',
    "NFI (Chino)",
    "NFI - ONTARIO SITE",
    "GAP CANADA (SITE GA7)",
    "WAINRIGHT TRUCKING LIMITED",
    "DSR - DELTA",
    "DSR Terminal",
    "GVN TRANSPORT LTD",
    "WINNIPEG CROSSDOCK & LOGISTICS INC",
    "LEO GREEN LOGISTIC"
  ]

  // initialize arrays for mat selection dropdowns
  typeListCarrier = {
    "4354d4bc-7a69-4d7b-b29b-16e62a56f2ee" : "Unassigned Carrier",
    "30c5ddb6-1f84-4d78-bed6-08a1b588620f": "CONSOLIDATED FASTFRATE INC.",
    "3cb053b5-524a-41f1-87c4-101c8d503153": "CROSS MILES CARRIER INC",
    "12cb5d65-3fb5-4f85-997a-481ff20a8481": "PINNACLE TRANSPORT LIMITED COMPANY",
    "7919233f-d47c-4c78-b9ad-3995da55ac29": "GARDEWINE TRANSPORT",
    "bde8cfd4-b91d-4a4a-a313-3f6b82c1a13b": "COUNTY TRANSPORT",
    "53e2fc1f-744e-4f15-a7a5-6328e506af21": "WEST METRO EXPRESS",
    "8f83895e-f813-4d7e-b03d-904508e3e3ad": "WAINRIGHT TRUCKING LIMITED",
    "db2ceccf-af6b-44ed-9fdf-eaf67edda346": "BANDSTRA TRANSPORTATION SYSTEMS LIMITED",
	  "22c7bc72-ca96-459e-9cf7-2a8ec0c6b29e": "HIGHLIGHT MOTOR FREIGHT",
    "0e61ea6f-0b3f-4c4d-a631-2e7a91fbc8bf": "DSR LOGISTICS INC",
    "757dd788-1640-41f6-bbb0-e7fd777a0bff": "GVN TRANSPORT LTD",
    "678b65fb-c14b-4b08-b3f9-8036f3cf9943": "GRIMSHAW TRUCKING (2005) LIMITED",
    "e8990494-a5d8-43f5-bdf5-4a531e53e760": "WINNIPEG CROSSDOCK & LOGISTICS INC",
    "037c46f1-693c-4640-bc42-177938b1aa71": "SUPERNOVA FREIGHT LTD"
  }

  typeListContainers: string[] = ["None"]

  // headers for the pallets grid
  palletsColumnDefs = [
    { field: 'load_no', headerName: 'Load No.' },
    { field: 'length', headerName: 'Length' },
    { field: 'width', headerName: 'Width' },
    { field: 'height', headerName: 'Height' },
    { field: 'weight', headerName: 'Weight' },
    { field: 'cartons_pallet', headerName: 'Carton Count' },
  ]

  constructor(private http: HttpClient, private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private dialog: MatDialog, private destinationService: ShipmentDestinationService) {
    this.shipment_list_uuid = data.shipment_list_uuid
  }

  // load shipment details data on startup (modal opened)
  ngOnInit() {
    this.getShipmentData();
  }

  getKeyByValue(obj: any, valueToFind: string) {
    for (var key in obj) {
      if (obj[key] === valueToFind) {
        return key;
      }
    }
    // Return null if the value is not found
    return null;
  }

  getValueShipper() {
    return Object.values(this.typeListShipper);
  }

  getValueCarrier() {
    return Object.values(this.typeListCarrier);
  }

  private emptyShipmentDetails(): any {
    return {
      details: {},
      consignee: {},
      consignee_address: {},
      carrier: {},
      carrier_address: {},
      operation: {},
    };
  }

  private normalizeShipmentDetails(response: any): any {
    const safe = response ?? {};
    return {
      ...safe,
      details: safe.details ?? {},
      consignee: safe.consignee ?? {},
      consignee_address: safe.consignee_address ?? {},
      carrier: safe.carrier ?? {},
      carrier_address: safe.carrier_address ?? {},
      operation: safe.operation ?? {},
    };
  }

  reconcileAddress(): void {
    if (this.isReconcilingAddress || this.isLoading || !this.contactForm) return;
    this.isReconcilingAddress = true;
    this.addressReconcileMessage = '';
    this.addressReconcileError = false;
    this.destinationService.currentPoolStoreDestination(this.shipment_list_uuid)
      .pipe(finalize(() => this.isReconcilingAddress = false))
      .subscribe({
        next: response => {
          if (String(response.code) !== '200' || !response.consignee?.contact_uuid || !response.consignee_address?.contact_address_uuid) {
            this.addressReconcileError = true;
            this.addressReconcileMessage = response.message || 'The current pool-store address could not be resolved.';
            return;
          }
          const contact = response.consignee;
          const address = response.consignee_address;
          this.contactForm.patchValue({
            consignee_contact_uuid: contact.contact_uuid,
            consignee_address_uuid: address.contact_address_uuid,
            consignee_company_name: contact.contact_organization ?? '',
            consignee_address_street: address.address_street ?? '',
            consignee_address_locality: address.address_locality ?? '',
            consignee_address_region: address.address_region ?? '',
            consignee_address_postal_code: address.address_postal_code ?? '',
            consignee_address_country: address.address_country ?? '',
          });
          this.shipment_details.consignee = contact;
          this.shipment_details.consignee_address = address;
          this.addressReconcileMessage = 'Address reconciled to the current pool store.';
        },
        error: () => {
          this.addressReconcileError = true;
          this.addressReconcileMessage = 'Could not load the current pool-store address. Try again.';
        },
      });
  }

  // function to retrieve the shipment detail data and pro bill
  getShipmentData() {

    const shipment_details_url = `/api/shipment_lists/shipment_details.php?uuid=${this.shipment_list_uuid}`;
    const shipment_pro_bill_url = `/api/shipment_lists/shipment_pro_bill.php?`;

    console.log("url:", shipment_details_url)
  
    // GET request to the contacts API call for specific contact_UUID
    this.http.get<any>(shipment_details_url).subscribe(response => {

      this.shipment_details = this.normalizeShipmentDetails(response)
      this.appointment_day_of_the_week = this.shipment_details.operation.appointment_day      
      this.store_number = this.shipment_details.details?.store_number ?? ''
      this.pallets = Array.isArray(response?.pallets) ? response.pallets : []
      this.containers = Array.isArray(response?.container) ? response.container : []
      this.typeListContainers = this.typeListContainers.concat(this.containers.map(container => `${container.store_number} Manifest ID: ${container.manifest_id}`))
      this.load_02 = response.load_02
      this.load_03 = response.load_03
      this.checkFormReady()
    })
	  
    if ((this.shipment_details.carrier.contact_organization === 'CONSOLIDATED FASTFRATE INC') ||
		    (this.shipment_details.carrier.contact_organization === 'CONSOLIDATED FASTFRATE INC.'))
	  {
      // GET request to the contacts API call for specific contact_UUID
      this.http.get<any>(shipment_pro_bill_url).subscribe(response => {

        this.pro_bill = response.pro_bill
        console.log('pro_bill', this.pro_bill)

      })
    }
  }

  handleSelectionChange(event: any): void {
    const selectedText = event.source.triggerValue;
    const selectedValue = this.getKeyByValue(this.typeListShipper, selectedText);
    if (selectedValue === "90a8a818-1107-4f16-9609-b0c7d06d9eac") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "7c495977-6179-48a6-861a-b6ca45e11913",
        shipper_company_name: 'THE FBI GROUP (SPIRIT)',
        shipper_address_street: "1380 CREDITSTONE ROAD",
        shipper_address_extended: 'Unit 3',
        shipper_address_locality: 'VAUGHAN',
        shipper_address_region: 'ON',
        shipper_address_postal_code: 'L4K 0J1',
        shipper_address_country: 'CANADA'
      });
    }
    else if (selectedValue === "e598ef72-7c41-41bc-920f-9a7d94e16ba7") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "bf1e4c43-c0df-40b8-9f92-8f5f4677dc89",
        shipper_company_name: 'SPENCER GIFTS C/O THE FBI GROUP',
        shipper_address_street: "1380 CREDITSTONE ROAD",
        shipper_address_extended: 'Unit 3',
        shipper_address_locality: 'VAUGHAN',
        shipper_address_region: 'ON',
        shipper_address_postal_code: 'L4K 0J1',
        shipper_address_country: 'CANADA'
      });
    } 
    else if (selectedValue === "abd4daf1-3544-4b0e-8730-831ae92844f0") 
      {
        this.contactForm.patchValue({
          shipper_contact_uuid: selectedValue,
          shipper_address_uuid: "98d98253-c7d5-4599-a07b-24c26b1bdec9",
          shipper_company_name: 'THE FBI GROUP C/O STRYDER (SITE FB2)',
          shipper_address_street: "490 CARMEK DRIVE SUITE 2",
          shipper_address_extended: '',
          shipper_address_locality: 'CALGARY',
          shipper_address_region: 'AB',
          shipper_address_postal_code: 'T1X 2P9',
          shipper_address_country: 'CANADA'
        });      
      }        
    else if (selectedValue === "2c15c45e-8f88-494a-8752-c2bd7281a094")
      {
        this.contactForm.patchValue({
          shipper_contact_uuid: selectedValue,
          shipper_address_uuid: "29951331-bb93-4cc3-b6b8-d68cab1755e9",
          shipper_company_name: 'STRYDER - VBC',
          shipper_address_street: "13240 WORSTER COURT",
          shipper_address_extended: '',
          shipper_address_locality: 'RICHMOND',
          shipper_address_region: 'BC',
          shipper_address_postal_code: 'V6V 2B8',
          shipper_address_country: 'CANADA'
        });
      }
    else if (selectedValue === "fcb24475-d4c4-4f49-9532-933704298976") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "2b1abfe4-4df4-4c9a-bb90-03da11611ee8",
        shipper_company_name: 'CONSOLIDATED FASTFRATE INC. (CALGARY)',
        shipper_address_street: "11440 - 54TH STREET SE",
        shipper_address_extended: '',
        shipper_address_locality: 'CALGARY',
        shipper_address_region: 'AB',
        shipper_address_postal_code: 'T2C 4Y6',
        shipper_address_country: 'CANADA'
      });
    }
    else if (selectedValue === "9fc6f259-3434-4ca0-acd2-b3a1194e8072") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "2bffc0bc-2a90-4059-a210-1b19cf3426bd",
        shipper_company_name: 'CONSOLIDATED FASTFRATE INC. (EDMONTON)',
        shipper_address_street: "101ST STREET",
        shipper_address_extended: 'Unit 7705',
        shipper_address_locality: 'EDMONTON',
        shipper_address_region: 'AB',
        shipper_address_postal_code: 'T5J 2M1',
        shipper_address_country: 'CANADA'
      });
    }
    else if (selectedValue === "ab1f86a3-07ec-4c10-9525-3ed34c7cf5eb") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "880a7423-e111-495a-8e0d-459810008dd6",
        shipper_company_name: 'CONSOLIDATED FASTFRATE INC. (VANCOUVER)',
        shipper_address_street: "1375 KINGSWAY AVENUE",
        shipper_address_extended: 'PO BOX 100',
        shipper_address_locality: 'PORT COQUITLAM',
        shipper_address_region: 'BC',
        shipper_address_postal_code: 'V3C 4W1',
        shipper_address_country: 'CANADA'
      });
    }
    else if (selectedValue === "34057143-bdc8-4a7b-bf6f-79fc53ae4318") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "b984c1fd-10c2-4c6c-b8ab-4a6300a9e893",
        shipper_company_name: 'CONSOLIDATED FASTFRATE INC (WINNIPEG)',
        shipper_address_street: "477 KEEWATIN STREET",
        shipper_address_extended: '',
        shipper_address_locality: 'WINNIPEG',
        shipper_address_region: 'MB',
        shipper_address_postal_code: 'R2X 2S1',
        shipper_address_country: 'CANADA'
      });
    }
    else if (selectedValue === "4a8b8b58-f5ff-4a8d-a408-9c3cbbdc5c7c") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "32f0b94f-e0c3-4f7c-977b-2a34b9ec2aaf",
        shipper_company_name: 'SG DISTRIBUTION CENTER (Pineville)',
        shipper_address_street: "10627 NATIONS FORD ROAD",
        shipper_address_extended: '',
        shipper_address_locality: 'PINEVILLE',
        shipper_address_region: 'NC',
        shipper_address_postal_code: '28134',
        shipper_address_country: 'UNITED STATES'
      });
    }
    else if (selectedValue === "a980a12f-743e-419c-8e3c-676e64305a47") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "c59886e1-44f3-4986-ad5a-85ce1d54cb8a",
        shipper_company_name: 'NFI (Chino)',
        shipper_address_street: "14701 YORBA AVENUE",
        shipper_address_extended: '',
        shipper_address_locality: 'CHINO',
        shipper_address_region: 'CA',
        shipper_address_postal_code: '91710',
        shipper_address_country: 'UNITED STATES'
      });
    }
    else if (selectedValue === "10865029-e760-477a-bc14-94b9328f079d") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "9573c302-9d3c-49e6-8f3f-708fef7b7c45",
        shipper_company_name: 'NFI - ONTARIO SITE',
        shipper_address_street: "4061 EAST FRANCIS STREET",
        shipper_address_extended: '',
        shipper_address_locality: 'ONTARIO',
        shipper_address_region: 'CA',
        shipper_address_postal_code: '91761',
        shipper_address_country: 'UNITED STATES'
      });
    }
    else if (selectedValue === "e420767d-7549-4e52-a2fe-5d0036413dfc") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "2279a908-3712-461b-8586-dd59825085f7",
        shipper_company_name: 'NFI - FREDERICKSBURG',
        shipper_address_street: "2869 OLD US 22",
        shipper_address_extended: '',
        shipper_address_locality: 'FREDERICKSBURG',
        shipper_address_region: 'PA',
        shipper_address_postal_code: '17026',
        shipper_address_country: 'UNITED STATES'
      });
    }    
    else if (selectedValue === "d9b23c14-069a-4eb6-972f-8ff9c498bb20") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "ebc0992c-2db7-4afc-80cc-0c3e40248277",
        shipper_company_name: 'GAP CANADA (SITE GA7)',
        shipper_address_street: "2190 Scanlan St",
        shipper_address_extended: '',
        shipper_address_locality: 'London',
        shipper_address_region: 'ON',
        shipper_address_postal_code: 'N5W 6G8',
        shipper_address_country: 'CANADA'
      });
    }        
    else if (selectedValue === "8f83895e-f813-4d7e-b03d-904508e3e3ad") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "d59bc14f-004f-4bc8-a896-86a6f65556ff",
        shipper_company_name: 'WAINRIGHT TRUCKING LIMITED',
        shipper_address_street: "420 INDUSTRIAL ROAD UNIT# 2",
        shipper_address_extended: '',
        shipper_address_locality: 'LONDON',
        shipper_address_region: 'ON',
        shipper_address_postal_code: 'N5V 1T4',
        shipper_address_country: 'CANADA'
      });
    }  
    else if (selectedValue === "4523aeef-6e85-4d0d-b221-44b4ccdddcb8") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "70f9442b-3684-4826-a212-7d0cfbe47604",
        shipper_company_name: 'DSR Terminal',
        shipper_address_street: "109-292164 WAGON WHEEL BLVD",
        shipper_address_extended: '',
        shipper_address_locality: 'ROCKY VIEW COUNTY',
        shipper_address_region: 'AB',
        shipper_address_postal_code: 'T4A 0T5',
        shipper_address_country: 'CANADA'
      });
    }   
    else if (selectedValue === "0d40741d-eabb-449c-b047-80df502dc900") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "f144e940-5a35-4eff-bb14-50e881adb46f",
        shipper_company_name: 'GVN TRANSPORT LTD',
        shipper_address_street: "3927 BRODSKY AVE",
        shipper_address_extended: '',
        shipper_address_locality: 'SASKATOON',
        shipper_address_region: 'SK',
        shipper_address_postal_code: 'S79 0C9',
        shipper_address_country: 'CANADA'
      });
    }   
    else if (selectedValue === "817009ae-a00e-4a83-b38b-62767abe4a1d") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "932a43a0-0f17-4694-8bd5-bfa3c818bfe0",
        shipper_company_name: 'WINNIPEG CROSSDOCK & LOGISTICS INC',
        shipper_address_street: "12 VERVAIN DRIVE",
        shipper_address_extended: '',
        shipper_address_locality: 'WINNIPEG',
        shipper_address_region: 'MB',
        shipper_address_postal_code: 'R2V 0M1',
        shipper_address_country: 'CANADA'
      });
    }   
    else if (selectedValue === "13e96812-85cf-46df-8562-69f2eb4b39ee") 
    {
      this.contactForm.patchValue({
        shipper_contact_uuid: selectedValue,
        shipper_address_uuid: "6fd2ab38-bf40-4036-8396-b39ddcbc6766",
        shipper_company_name: 'LEO GREEN LOGISTICS',
        shipper_address_street: "5805 98 ST NW DOCK 24",
        shipper_address_extended: '',
        shipper_address_locality: 'EDMONTON',
        shipper_address_region: 'AB',
        shipper_address_postal_code: 'T6E 3L4',
        shipper_address_country: 'CANADA'
      });
    }                   
  }

  handleSelectionChangeCarrier(event: any): void {
    const selectedText = event.source.triggerValue;
    const selectedOption = this.getKeyByValue(this.typeListCarrier, selectedText);
    if (selectedOption === this.shipment_details.carrier.contact_uuid) {
      const carrier = this.shipment_details.carrier;
      const address = this.shipment_details.carrier_address;
      this.contactForm.patchValue({
        carrier_contact_uuid: carrier.contact_uuid,
        carrier_address_uuid: address.contact_address_uuid,
        carrier_company_name: carrier.contact_organization,
        carrier_address_street: address.address_street,
        carrier_address_line_two: address.address_extended ?? '',
        carrier_address_locality: address.address_locality,
        carrier_address_region: address.address_region,
        carrier_address_postal_code: address.address_postal_code,
        carrier_address_country: address.address_country,
      });
      return;
    }

        if (selectedOption === "") 
        {
          // Unassigned Carrier
          this.contactForm.patchValue({
            carrier_contact_uuid: '',
            carrier_address_uuid: '',
            carrier_address_street: '',
            carrier_address_line_two: '',
            carrier_address_locality: '',
            carrier_address_region: '',
            carrier_address_postal_code: '',
            carrier_address_country: '',
          });          
        }
        else if (selectedOption === "30c5ddb6-1f84-4d78-bed6-08a1b588620f") 
        {
          // CONSOLIDATED FASTFRATE INC.
          this.contactForm.patchValue({
            carrier_contact_uuid: '30c5ddb6-1f84-4d78-bed6-08a1b588620f',
            carrier_address_uuid: '06446b11-f53b-47df-976d-7231180c3c7a',
            carrier_address_street: '9701 HIGHWAY 50',
            carrier_address_line_two: '',
            carrier_address_locality: 'WOODBRIDGE ',
            carrier_address_region: 'ON',
            carrier_address_postal_code: 'L4H 2G4',
            carrier_address_country: 'CANADA',
          });
        } 
        else if (selectedOption === "3cb053b5-524a-41f1-87c4-101c8d503153") 
        {
          // CROSS MILES CARRIER INC 
          this.contactForm.patchValue({
            carrier_contact_uuid: '3cb053b5-524a-41f1-87c4-101c8d503153',
            carrier_address_uuid: '5617b6e5-ab71-4f28-b6a4-15aa8d2e4e65',
            carrier_address_street: "96 KENNEDY ROAD SOUTH UNIT 203",
            carrier_address_line_two: '',
            carrier_address_locality: 'BRAMPTON',
            carrier_address_region: 'ON',
            carrier_address_postal_code: 'L6W 3E7',
            carrier_address_country: 'CANADA',
          });
        } 
        else if (selectedOption === "12cb5d65-3fb5-4f85-997a-481ff20a8481") 
        {
          // PINNACLE TRANSPORT LIMITED COMPANY
          this.contactForm.patchValue({
            carrier_contact_uuid: '12cb5d65-3fb5-4f85-997a-481ff20a8481',
            carrier_address_uuid: 'b04938aa-8d0d-4d89-a365-ab5355da6769',
            carrier_address_street: "81 SELECT AVENUE",
            carrier_address_line_two: '',
            carrier_address_locality: 'SCARBOROUGH',
            carrier_address_region: 'ON',
            carrier_address_postal_code: 'M1V 4A9',
            carrier_address_country: 'CANADA',
          });
        } 
        else if (selectedOption === "7919233f-d47c-4c78-b9ad-3995da55ac29") 
        {
          // GARDEWINE TRANSPORT
          this.contactForm.patchValue({
            carrier_contact_uuid: '7919233f-d47c-4c78-b9ad-3995da55ac29',
            carrier_address_uuid: 'd364f035-aa47-436a-85d9-14e8302b4652',
            carrier_address_street: "60 EAGLE DRIVE",
            carrier_address_line_two: '',
            carrier_address_locality: 'WINNIPEG',
            carrier_address_region: 'MB',
            carrier_address_postal_code: 'R2R 1V5',
            carrier_address_country: 'CANADA',
          });
        } 
        else if (selectedOption === "bde8cfd4-b91d-4a4a-a313-3f6b82c1a13b") 
        {
          // COUNTY TRANSPORT
          this.contactForm.patchValue({
            carrier_contact_uuid: 'bde8cfd4-b91d-4a4a-a313-3f6b82c1a13b',
            carrier_address_uuid: '0101bb27-2eaa-425e-827f-c89c74722e15',
            carrier_address_street: "250 SIDNEY STREET",
            carrier_address_line_two: '',
            carrier_address_locality: 'BELLEVILLE',
            carrier_address_region: 'ON',
            carrier_address_postal_code: 'K8P 3Z3',
            carrier_address_country: 'CANADA',
          });
        } 
        else if (selectedOption === "53e2fc1f-744e-4f15-a7a5-6328e506af21") 
        {
            // WEST METRO EXPRESS
            this.contactForm.patchValue({
              carrier_contact_uuid: '53e2fc1f-744e-4f15-a7a5-6328e506af21',
              carrier_address_uuid: '06446b11-f53b-47df-976d-7231180c3c7a',
              carrier_address_street: "394569 ONTARIO LIMITED 5315 GENERAL ROAD",
              carrier_address_line_two: '',
              carrier_address_locality: 'MISSISSAUGA',
              carrier_address_region: 'ON',
              carrier_address_postal_code: 'L4W 2K4',
              carrier_address_country: 'CANADA',
            });
        }         
        else if (selectedOption === "c439802c-f3c1-47a7-8e0e-021693d5a462") 
        {
            // WAINRIGHT TRUCKING LIMITED
            this.contactForm.patchValue({
              carrier_contact_uuid: 'c439802c-f3c1-47a7-8e0e-021693d5a462',
              carrier_address_uuid: 'd59bc14f-004f-4bc8-a896-86a6f65556ff',
              carrier_address_street: "420 INDUSTRIAL ROAD UNIT# 2",
              carrier_address_line_two: '',
              carrier_address_locality: 'LONDON',
              carrier_address_region: 'ON',
              carrier_address_postal_code: 'N5V 1T4',
              carrier_address_country: 'CANADA',
            });
        }    
        else if (selectedOption === "db2ceccf-af6b-44ed-9fdf-eaf67edda346") 
        {
            // BANDSTRA TRANSPORTATION SYSTEMS LIMITED
            this.contactForm.patchValue({
              carrier_contact_uuid: 'db2ceccf-af6b-44ed-9fdf-eaf67edda346',
              carrier_address_uuid: '135c08aa-bd5e-460e-bfcd-3c95083ed177',
              carrier_address_street: "3394 E. YELLOWHEAD HWY.",
              carrier_address_line_two: 'P.O. BOX 95',
              carrier_address_locality: 'SMITHERS',
              carrier_address_region: 'BC',
              carrier_address_postal_code: 'V0J 2N0',
              carrier_address_country: 'CANADA',
            });
        }        
        else if (selectedOption === "22c7bc72-ca96-459e-9cf7-2a8ec0c6b29e") 
        {
            // 	 HIGHLIGHT MOTOR FREIGHT
            this.contactForm.patchValue({
              carrier_contact_uuid: '22c7bc72-ca96-459e-9cf7-2a8ec0c6b29e',
              carrier_address_uuid: '5f2efe60-2d3d-42a5-a78a-5becb0b746e2',
              carrier_address_street: "500 CREDITSTONE ROAD",
              carrier_address_line_two: '',
              carrier_address_locality: 'CONCORD',
              carrier_address_region: 'ON',
              carrier_address_postal_code: 'L4K 3Z3',
              carrier_address_country: 'CANADA',
            });
        }             
        else if (selectedOption === "0e61ea6f-0b3f-4c4d-a631-2e7a91fbc8bf") 
        {
            // 	DSR LOGISTICS INC
            this.contactForm.patchValue({
              carrier_contact_uuid: '0e61ea6f-0b3f-4c4d-a631-2e7a91fbc8bf',
              carrier_address_uuid: '67e7700e-2ba9-46d2-8ebe-ba4148daf8a8',
              carrier_address_street: "109 - 7717 BEEDIE WAY",
              carrier_address_line_two: '',
              carrier_address_locality: 'DELTA',
              carrier_address_region: 'BC',
              carrier_address_postal_code: 'V4G 1M1',
              carrier_address_country: 'CANADA',
            });
        }    
        else if (selectedOption === "757dd788-1640-41f6-bbb0-e7fd777a0bff") 
        {
            // 	GVN TRANSPORT LTD
            this.contactForm.patchValue({
              carrier_contact_uuid: '757dd788-1640-41f6-bbb0-e7fd777a0bff',
              carrier_address_uuid: '9573f48d-e6a2-40e2-84ca-3d4372a1a600',
              carrier_address_street: "507 ENS LANE PO BOX 125",
              carrier_address_line_two: '',
              carrier_address_locality: 'WARMAN',
              carrier_address_region: 'SK',
              carrier_address_postal_code: 'S0K 4S0',
              carrier_address_country: 'CANADA',
            });
        }    
        else if (selectedOption === "678b65fb-c14b-4b08-b3f9-8036f3cf9943") 
        {
            // 	GRIMSHAW TRUCKING (2005) LIMITED
            this.contactForm.patchValue({
              carrier_contact_uuid: '678b65fb-c14b-4b08-b3f9-8036f3cf9943',
              carrier_address_uuid: '4d15eabf-8595-4b23-b5da-98f3950f6813',
              carrier_address_street: "11510 - 151 STREET",
              carrier_address_line_two: '',
              carrier_address_locality: 'EDMONTON',
              carrier_address_region: 'AB',
              carrier_address_postal_code: 'T5M 3N6',
              carrier_address_country: 'CANADA',
            });
        }    
        else if (selectedOption === "e8990494-a5d8-43f5-bdf5-4a531e53e760") 
        {
            // 	WINNIPEG CROSSDOCK & LOGISTICS INC
            this.contactForm.patchValue({
              carrier_contact_uuid: 'e8990494-a5d8-43f5-bdf5-4a531e53e760',
              carrier_address_uuid: '93178ac6-8cf7-4c59-a248-e31fb29cd9bd',
              carrier_address_street: "12 VERVAIN DRIVE",
              carrier_address_line_two: '',
              carrier_address_locality: 'WINNIPEG',
              carrier_address_region: 'MB',
              carrier_address_postal_code: 'R2V 0M1',
              carrier_address_country: 'CANADA',
            });
        }     
        else if (selectedOption === "037c46f1-693c-4640-bc42-177938b1aa71") 
        {
            // 	WINNIPEG CROSSDOCK & LOGISTICS INC
            this.contactForm.patchValue({
              carrier_contact_uuid: '037c46f1-693c-4640-bc42-177938b1aa71',
              carrier_address_uuid: '51d51c21-ab30-4395-b718-ea90c36c7a75',
              carrier_address_street: "7176 EDGEMONT WAY NW",
              carrier_address_line_two: '',
              carrier_address_locality: 'EDMONTON',
              carrier_address_region: 'AB',
              carrier_address_postal_code: 'T6M 1K1',
              carrier_address_country: 'CANADA',
            });
        }                                                     
      };

      handleSelectionChangeIntermodalCarrier(event: any): void {
        const selectedText = event.source.triggerValue;
        const selectedOption = this.getKeyByValue(this.typeListCarrier, selectedText);
            if (selectedOption === "") 
            {
              // Unassigned Carrier
              this.contactForm.patchValue({
                intermodal_carrier_contact_uuid: '',
                intermodal_carrier_address_uuid: '',
                intermodal_carrier_address_street: '',
                intermodal_carrier_address_line_two: '',
                intermodal_carrier_address_locality: '',
                intermodal_carrier_address_region: '',
                intermodal_carrier_address_postal_code: '',
                intermodal_carrier_address_country: '',
              });        
            }
            else if (selectedOption === "30c5ddb6-1f84-4d78-bed6-08a1b588620f") 
            {
              // CONSOLIDATED FASTFRATE INC.
              this.contactForm.patchValue({
                intermodal_carrier_contact_uuid: '30c5ddb6-1f84-4d78-bed6-08a1b588620f',
                intermodal_carrier_address_uuid: '06446b11-f53b-47df-976d-7231180c3c7a',
                intermodal_carrier_address_street: '9701 HIGHWAY 50',
                intermodal_carrier_address_line_two: '',
                intermodal_carrier_address_locality: 'WOODBRIDGE ',
                intermodal_carrier_address_region: 'ON',
                intermodal_carrier_address_postal_code: 'L4H 2G4',
                intermodal_carrier_address_country: 'CANADA',
              });
            } 
            else if (selectedOption === "3cb053b5-524a-41f1-87c4-101c8d503153") 
            {
              // CROSS MILES CARRIER INC 
              this.contactForm.patchValue({
                intermodal_carrier_contact_uuid: '3cb053b5-524a-41f1-87c4-101c8d503153',
                intermodal_carrier_address_uuid: '5617b6e5-ab71-4f28-b6a4-15aa8d2e4e65',
                intermodal_carrier_address_street: "96 KENNEDY ROAD SOUTH UNIT 203",
                intermodal_carrier_address_line_two: '',
                intermodal_carrier_address_locality: 'BRAMPTON',
                intermodal_carrier_address_region: 'ON',
                intermodal_carrier_address_postal_code: 'L6W 3E7',
                intermodal_carrier_address_country: 'CANADA',
              });
            }             
            else if (selectedOption === "12cb5d65-3fb5-4f85-997a-481ff20a8481") 
            {
              // PINNACLE TRANSPORT LIMITED COMPANY
              this.contactForm.patchValue({
                intermodal_carrier_contact_uuid: '12cb5d65-3fb5-4f85-997a-481ff20a8481',
                intermodal_carrier_address_uuid: 'b04938aa-8d0d-4d89-a365-ab5355da6769',
                intermodal_carrier_address_street: "81 SELECT AVENUE",
                intermodal_carrier_address_line_two: '',
                intermodal_carrier_address_locality: 'SCARBOROUGH',
                intermodal_carrier_address_region: 'ON',
                intermodal_carrier_address_postal_code: 'M1V 4A9',
                intermodal_carrier_address_country: 'CANADA',
              });
            } 
            else if (selectedOption === "7919233f-d47c-4c78-b9ad-3995da55ac29") 
            {
              // GARDEWINE TRANSPORT
              this.contactForm.patchValue({
                intermodal_carrier_contact_uuid: '7919233f-d47c-4c78-b9ad-3995da55ac29',
                intermodal_carrier_address_uuid: 'd364f035-aa47-436a-85d9-14e8302b4652',
                intermodal_carrier_address_street: "60 EAGLE DRIVE",
                intermodal_carrier_address_line_two: '',
                intermodal_carrier_address_locality: 'WINNIPEG',
                intermodal_carrier_address_region: 'MB',
                intermodal_carrier_address_postal_code: 'R2R 1V5',
                intermodal_carrier_address_country: 'CANADA',
              });
            } 
            else if (selectedOption === "bde8cfd4-b91d-4a4a-a313-3f6b82c1a13b") 
            {
              // COUNTY TRANSPORT
              this.contactForm.patchValue({
                intermodal_carrier_contact_uuid: 'bde8cfd4-b91d-4a4a-a313-3f6b82c1a13b',
                intermodal_carrier_address_uuid: '0101bb27-2eaa-425e-827f-c89c74722e15',
                intermodal_carrier_address_street: "250 SIDNEY STREET",
                intermodal_carrier_address_line_two: '',
                intermodal_carrier_address_locality: 'BELLEVILLE',
                intermodal_carrier_address_region: 'ON',
                intermodal_carrier_address_postal_code: 'K8P 3Z3',
                intermodal_carrier_address_country: 'CANADA',
              });
            } 
            else if (selectedOption === "53e2fc1f-744e-4f15-a7a5-6328e506af21") 
            {
                // WEST METRO EXPRESS
                this.contactForm.patchValue({
                  intermodal_carrier_contact_uuid: '53e2fc1f-744e-4f15-a7a5-6328e506af21',
                  intermodal_carrier_address_uuid: '06446b11-f53b-47df-976d-7231180c3c7a',
                  intermodal_carrier_address_street: "394569 ONTARIO LIMITED 5315 GENERAL ROAD",
                  intermodal_carrier_address_line_two: '',
                  intermodal_carrier_address_locality: 'MISSISSAUGA',
                  intermodal_carrier_address_region: 'ON',
                  intermodal_carrier_address_postal_code: 'L4W 2K4',
                  intermodal_carrier_address_country: 'CANADA',
                });
            }         
            else if (selectedOption === "c439802c-f3c1-47a7-8e0e-021693d5a462") 
            {
                // WAINRIGHT TRUCKING LIMITED
                this.contactForm.patchValue({
                  intermodal_carrier_contact_uuid: 'c439802c-f3c1-47a7-8e0e-021693d5a462',
                  intermodal_carrier_address_uuid: 'd59bc14f-004f-4bc8-a896-86a6f65556ff',
                  intermodal_carrier_address_street: "420 INDUSTRIAL ROAD UNIT# 2",
                  intermodal_carrier_address_line_two: '',
                  intermodal_carrier_address_locality: 'LONDON',
                  intermodal_carrier_address_region: 'ON',
                  intermodal_carrier_address_postal_code: 'N5V 1T4',
                  intermodal_carrier_address_country: 'CANADA',
                });
            }     
            else if (selectedOption === "db2ceccf-af6b-44ed-9fdf-eaf67edda346") 
            {
                // BANDSTRA TRANSPORTATION SYSTEMS LIMITED
                this.contactForm.patchValue({
                  intermodal_carrier_contact_uuid: 'db2ceccf-af6b-44ed-9fdf-eaf67edda346',
                  intermodal_carrier_address_uuid: '135c08aa-bd5e-460e-bfcd-3c95083ed177',
                  intermodal_carrier_address_street: "3394 E. YELLOWHEAD HWY.",
                  intermodal_carrier_address_line_two: 'P.O. BOX 95',
                  intermodal_carrier_address_locality: 'SMITHERS',
                  intermodal_carrier_address_region: 'BC',
                  intermodal_carrier_address_postal_code: 'V0J 2N0',
                  intermodal_carrier_address_country: 'CANADA',
                });
            }        
            else if (selectedOption === "22c7bc72-ca96-459e-9cf7-2a8ec0c6b29e") 
            {
                // 	 HIGHLIGHT MOTOR FREIGHT
                this.contactForm.patchValue({
                  carrier_contintermodal_carrier_contact_uuidact_uuid: '22c7bc72-ca96-459e-9cf7-2a8ec0c6b29e',
                  intermodal_carrier_address_uuid: '5f2efe60-2d3d-42a5-a78a-5becb0b746e2',
                  intermodal_carrier_address_street: "500 CREDITSTONE ROAD",
                  intermodal_carrier_address_line_two: '',
                  intermodal_carrier_address_locality: 'CONCORD',
                  intermodal_carrier_address_region: 'ON',
                  intermodal_carrier_address_postal_code: 'L4K 3Z3',
                  intermodal_carrier_address_country: 'CANADA',
                });
            }           
            else if (selectedOption === "0e61ea6f-0b3f-4c4d-a631-2e7a91fbc8bf") 
            {
                // 	DSR LOGISTICS INC
                this.contactForm.patchValue({
                  intermodal_carrier_contact_uuid: '0e61ea6f-0b3f-4c4d-a631-2e7a91fbc8bf',
                  intermodal_carrier_address_uuid: '67e7700e-2ba9-46d2-8ebe-ba4148daf8a8',
                  intermodal_carrier_address_street: "109 - 7717 BEEDIE WAY",
                  intermodal_carrier_address_line_two: '',
                  intermodal_carrier_address_locality: 'DELTA',
                  intermodal_carrier_address_region: 'BC',
                  intermodal_carrier_address_postal_code: 'V4G 1M1',
                  intermodal_carrier_address_country: 'CANADA',
                });
            }    
            else if (selectedOption === "757dd788-1640-41f6-bbb0-e7fd777a0bff") 
            {
                // 	GVN TRANSPORT LTD
                this.contactForm.patchValue({
                  intermodal_carrier_contact_uuid: '757dd788-1640-41f6-bbb0-e7fd777a0bff',
                  intermodal_carrier_address_uuid: '9573f48d-e6a2-40e2-84ca-3d4372a1a600',
                  intermodal_carrier_address_street: "507 ENS LANE PO BOX 125",
                  intermodal_carrier_address_line_two: '',
                  intermodal_carrier_address_locality: 'WARMAN',
                  intermodal_carrier_address_region: 'SK',
                  intermodal_carrier_address_postal_code: 'S0K 4S0',
                  intermodal_carrier_address_country: 'CANADA',
                });
            }    
            else if (selectedOption === "678b65fb-c14b-4b08-b3f9-8036f3cf9943") 
            {
                // 	GRIMSHAW TRUCKING (2005) LIMITED
                this.contactForm.patchValue({
                  intermodal_carrier_contact_uuid: '678b65fb-c14b-4b08-b3f9-8036f3cf9943',
                  intermodal_carrier_address_uuid: '4d15eabf-8595-4b23-b5da-98f3950f6813',
                  intermodal_carrier_address_street: "11510 - 151 STREET",
                  intermodal_carrier_address_line_two: '',
                  intermodal_carrier_address_locality: 'EDMONTON',
                  intermodal_carrier_address_region: 'AB',
                  intermodal_carrier_address_postal_code: 'T5M 3N6',
                  intermodal_carrier_address_country: 'CANADA',
                });
            }    
            else if (selectedOption === "e8990494-a5d8-43f5-bdf5-4a531e53e760") 
            {
                // 	WINNIPEG CROSSDOCK & LOGISTICS INC
                this.contactForm.patchValue({
                  intermodal_carrier_contact_uuid: 'e8990494-a5d8-43f5-bdf5-4a531e53e760',
                  intermodal_carrier_address_uuid: '93178ac6-8cf7-4c59-a248-e31fb29cd9bd',
                  intermodal_carrier_address_street: "12 VERVAIN DRIVE",
                  intermodal_carrier_address_line_two: '',
                  intermodal_carrier_address_locality: 'WINNIPEG',
                  intermodal_carrier_address_region: 'MB',
                  intermodal_carrier_address_postal_code: 'R2V 0M1',
                  intermodal_carrier_address_country: 'CANADA',
                });
            }                                               
            else if (selectedOption === "037c46f1-693c-4640-bc42-177938b1aa71") 
            {
                // 	WINNIPEG CROSSDOCK & LOGISTICS INC
                this.contactForm.patchValue({
                  intermodal_carrier_contact_uuid: '037c46f1-693c-4640-bc42-177938b1aa71',
                  intermodal_carrier_address_uuid: '51d51c21-ab30-4395-b718-ea90c36c7a75',
                  intermodal_carrier_address_street: "7176 EDGEMONT WAY NW",
                  intermodal_carrier_address_line_two: '',
                  intermodal_carrier_address_locality: 'EDMONTON',
                  intermodal_carrier_address_region: 'AB',
                  intermodal_carrier_address_postal_code: 'T6M 1K1',
                  intermodal_carrier_address_country: 'CANADA',
                });
            }    
          };

  // function to prepare form data upon GET API finishing retrieving the shipment details
  private checkFormReady(): void {

    if (this.shipment_details) {

      console.log('shipment info', this.shipment_details);
      const defaultCarrier = this.shipment_details.carrier;
      if (defaultCarrier.contact_uuid && defaultCarrier.contact_organization) {
        this.typeListCarrier = { ...this.typeListCarrier,
          [defaultCarrier.contact_uuid]: defaultCarrier.contact_organization };
      }


      this.contactForm = this.formBuilder.group({

        customer_contact_uuid: [''],
        customer_address_uuid: [''],
        shipment_list_uuid: [this.shipment_details.details.shipment_list_uuid],
        customer_company_name: ['', Validators.required],
        customer_address: ['', Validators.required],
        companyAddress2: [''],
        companyAddress3: [''],
        customer_city: ['', Validators.required],
        customer_region: ['', Validators.required],
        customer_country_code: ['', Validators.required],
        customer_postal_code: ['', Validators.required],

        consignee_contact_uuid: [this.shipment_details.consignee.contact_uuid],
        consignee_address_uuid: [this.shipment_details.consignee_address.contact_address_uuid],
        consignee_company_name: [this.shipment_details.consignee.contact_organization],
        consignee_address_street: [this.shipment_details.consignee_address.address_street],
        consignee_address_locality: [this.shipment_details.consignee_address.address_locality],
        consignee_address_region: [this.shipment_details.consignee_address.address_region],
        consignee_address_postal_code: [this.shipment_details.consignee_address.address_postal_code],
        consignee_address_country: [this.shipment_details.consignee_address.address_country],

        carrier_contact_uuid: [this.shipment_details.carrier.contact_uuid],
        carrier_address_uuid: [this.shipment_details.carrier_address.contact_address_uuid],
        carrier_company_name: [this.shipment_details.carrier.contact_organization],
        carrier_address_street: [this.shipment_details.carrier_address.address_street],
        carrier_address_line_two: [this.shipment_details.carrier_address.address_extended],
        carrier_address_locality: [this.shipment_details.carrier_address.address_locality],
        carrier_address_region: [this.shipment_details.carrier_address.address_region],
        carrier_address_postal_code: [this.shipment_details.carrier_address.address_postal_code],
        carrier_address_country: [this.shipment_details.carrier_address.address_country],

        shipper_contact_uuid: ['90a8a818-1107-4f16-9609-b0c7d06d9eac'],
        shipper_address_uuid: ['7c495977-6179-48a6-861a-b6ca45e11913'],
        shipper_company_name: ['THE FBI GROUP (SPIRIT)', Validators.required],
        shipper_address_street: ['1380 CREDITSTONE ROAD'],
        shipper_address_extended: ['Unit 3'],
        shipper_address_locality: ['VAUGHAN'],
        shipper_address_region: ['ON'],
        shipper_address_postal_code: ['L4K 0J1'],
        shipper_address_country: ['CANADA'],

        intermodal_contact_uuid: [''],
        intermodal_address_uuid: [''],
        intermodal_company_name: ['', Validators.required],
        intermodal_address: [''],
        intermodal_address_line_two: [''],
        intermodal_city: [''],
        intermodal_state_province_code: [''],
        intermodal_postal_code: [''],
        intermodal_country_code: [''],

        intermodal_carrier_contact_uuid: [this.shipment_details.carrier.contact_uuid],
        intermodal_carrier_company_name: [this.shipment_details.carrier.contact_organization],
        intermodal_carrier_address_street: [this.shipment_details.carrier_address.address_street],
        intermodal_carrier_address_line_two: [this.shipment_details.carrier_address.address_extended],
        intermodal_carrier_address_locality: [this.shipment_details.carrier_address.address_locality],
        intermodal_carrier_address_region: [this.shipment_details.carrier_address.address_region],
        intermodal_carrier_address_postal_code: [this.shipment_details.carrier_address.address_postal_code],
        intermodal_carrier_address_country: [this.shipment_details.carrier_address.address_country]

      })
      
      // Pre-populate the shipper section in the contact form depending on the shipper selected (selectedOption)

      // Pre-populate the intermodal leg section in the contact form depending on the consignee selected (selectedOption)
      this.contactForm.get('intermodal_company_name')?.valueChanges.subscribe(selectedValue => {
        let selectedOption = this.typeListConsigneeLeg.find(option => option === selectedValue);
        this.creationError = '';
        this.contactForm.patchValue({ intermodal_contact_uuid: '', intermodal_address_uuid: '' }, { emitEvent: false });
        console.log(' the option ', selectedOption)

        if (selectedOption === "THE FBI GROUP C/O STRYDER (SITE FB2)") 
          {
              this.contactForm.patchValue({
                shipper_contact_uuid: 'abd4daf1-3544-4b0e-8730-831ae92844f0',
                shipper_address_uuid: '98d98253-c7d5-4599-a07b-24c26b1bdec9',    
                shipper_company_name: "THE FBI GROUP C/O STRYDER (SITE FB2)",
                shipper_address_street: "490 CARMEK DRIVE SUITE 2",
                shipper_address_extended: '',
                shipper_address_locality: 'CALGARY',
                shipper_address_region: 'AB',
                shipper_address_postal_code: 'T1X 2P9',
                shipper_address_country: 'CANADA',
                intermodal_contact_uuid: 'abd4daf1-3544-4b0e-8730-831ae92844f0',
                intermodal_address_uuid: '98d98253-c7d5-4599-a07b-24c26b1bdec9',    
                intermodal_address: "490 CARMEK DRIVE SUITE 2",
                intermodal_address_line_two: '',
                intermodal_city: 'CALGARY',
                intermodal_state_province_code: 'AB',
                intermodal_postal_code: 'T1X 2P9',
                intermodal_country_code: 'CANADA'
              });
          }
        else if (selectedOption === "STRYDER - VBC")
          {
              this.contactForm.patchValue({
                shipper_contact_uuid: '2c15c45e-8f88-494a-8752-c2bd7281a094',
                shipper_address_uuid: '29951331-bb93-4cc3-b6b8-d68cab1755e9',
                shipper_company_name: "STRYDER - VBC",
                shipper_address_street: "13240 WORSTER COURT",
                shipper_address_extended: '',
                shipper_address_locality: 'RICHMOND',
                shipper_address_region: 'BC',
                shipper_address_postal_code: 'V6V 2B8',
                shipper_address_country: 'CANADA',
                intermodal_contact_uuid: '2c15c45e-8f88-494a-8752-c2bd7281a094',
                intermodal_address_uuid: '29951331-bb93-4cc3-b6b8-d68cab1755e9',
                intermodal_address: "13240 WORSTER COURT",
                intermodal_address_line_two: '',
                intermodal_city: 'RICHMOND',
                intermodal_state_province_code: 'BC',
                intermodal_postal_code: 'V6V 2B8',
                intermodal_country_code: 'CANADA'
              });
          }
        else if (selectedOption === "CONSOLIDATED FASTFRATE INC. (CALGARY)") 
        {
          this.contactForm.patchValue({
            shipper_contact_uuid: 'fcb24475-d4c4-4f49-9532-933704298976',
            shipper_address_uuid: '2b1abfe4-4df4-4c9a-bb90-03da11611ee8',
            shipper_company_name: "CONSOLIDATED FASTFRATE INC. (CALGARY)",
            shipper_address_street: "11440 - 54TH STREET SE",
            shipper_address_extended: '',
            shipper_address_locality: 'CALGARY',
            shipper_address_region: 'AB',
            shipper_address_postal_code: 'T2C 4Y6',
            shipper_address_country: 'CANADA',
            intermodal_contact_uuid: 'fcb24475-d4c4-4f49-9532-933704298976',
            intermodal_address_uuid: '2b1abfe4-4df4-4c9a-bb90-03da11611ee8',
            intermodal_address: "11440 - 54TH STREET SE",
            intermodal_address_line_two: '',
            intermodal_city: 'CALGARY',
            intermodal_state_province_code: 'AB',
            intermodal_postal_code: 'T2C 4Y6',
            intermodal_country_code: 'CANADA'
          });
        } 
        else if (selectedOption === "CONSOLIDATED FASTFRATE INC. (EDMONTON)") 
        {
          this.contactForm.patchValue({
            shipper_contact_uuid: '9fc6f259-3434-4ca0-acd2-b3a1194e8072',
            shipper_address_uuid: '2bffc0bc-2a90-4059-a210-1b19cf3426bd',
            shipper_company_name: "CONSOLIDATED FASTFRATE INC. (EDMONTON)",
            shipper_address_street: "101ST STREET",
            shipper_address_extended: 'Unit 7705',
            shipper_address_locality: 'EDMONTON',
            shipper_address_region: 'AB',
            shipper_address_postal_code: 'T5J 2M1',
            shipper_address_country: 'CANADA',
            intermodal_contact_uuid: '9fc6f259-3434-4ca0-acd2-b3a1194e8072',
            intermodal_address_uuid: '2bffc0bc-2a90-4059-a210-1b19cf3426bd',
            intermodal_address: "101ST STREET",
            intermodal_address_line_two: 'Unit 7705',
            intermodal_city: 'EDMONTON',
            intermodal_state_province_code: 'AB',
            intermodal_postal_code: 'T5J 2M1',
            intermodal_country_code: 'CANADA'
          });
        } 
        else if (selectedOption === "CONSOLIDATED FASTFRATE INC. (VANCOUVER)") 
        {
          this.contactForm.patchValue({
            shipper_contact_uuid: 'ab1f86a3-07ec-4c10-9525-3ed34c7cf5eb',
            shipper_address_uuid: '880a7423-e111-495a-8e0d-459810008dd6',
            shipper_company_name: "CONSOLIDATED FASTFRATE INC. (VANCOUVER)",
            shipper_address_street: "1375 KINGSWAY AVENUE",
            shipper_address_extended: 'PO BOX 100',
            shipper_address_locality: 'PORT COQUITLAM',
            shipper_address_region: 'BC',
            shipper_address_postal_code: 'V3C 4W1',
            shipper_address_country: 'CANADA',
            intermodal_contact_uuid: 'ab1f86a3-07ec-4c10-9525-3ed34c7cf5eb',
            intermodal_address_uuid: '880a7423-e111-495a-8e0d-459810008dd6',
            intermodal_address: "1375 KINGSWAY AVENUE",
            intermodal_address_line_two: 'PO BOX 100',
            intermodal_city: 'PORT COQUITLAM',
            intermodal_state_province_code: 'BC',
            intermodal_postal_code: 'V3C 4W1',
            intermodal_country_code: 'CANADA'
          });
        } 
        else if (selectedOption === "CONSOLIDATED FASTFRATE INC (WINNIPEG)") 
        {
          this.contactForm.patchValue({
            shipper_contact_uuid: '34057143-bdc8-4a7b-bf6f-79fc53ae4318',
            shipper_address_uuid: 'b984c1fd-10c2-4c6c-b8ab-4a6300a9e893',
            shipper_company_name: "CONSOLIDATED FASTFRATE INC (WINNIPEG)",
            shipper_address_street: "477 KEEWATIN STREET",
            shipper_address_extended: '',
            shipper_address_locality: 'WINNIPEG',
            shipper_address_region: 'MB',
            shipper_address_postal_code: 'R2X 2S1',
            shipper_address_country: 'CANADA',
            intermodal_contact_uuid: '34057143-bdc8-4a7b-bf6f-79fc53ae4318',
            intermodal_address_uuid: 'b984c1fd-10c2-4c6c-b8ab-4a6300a9e893',
            intermodal_address: "477 KEEWATIN STREET",
            intermodal_address_line_two: '',
            intermodal_city: 'WINNIPEG',
            intermodal_state_province_code: 'MB',
            intermodal_postal_code: 'R2X 2S1',
            intermodal_country_code: 'CANADA'
          });
        } 
        else if (selectedOption === 'SG DISTRIBUTION CENTER (Pineville)') 
        {
          this.contactForm.patchValue({
            shipper_contact_uuid: "4a8b8b58-f5ff-4a8d-a408-9c3cbbdc5c7c",
            shipper_address_uuid: "32f0b94f-e0c3-4f7c-977b-2a34b9ec2aaf",
            shipper_company_name: 'SG DISTRIBUTION CENTER (Pineville)',
            shipper_address_street: "10627 NATIONS FORD ROAD",
            shipper_address_extended: '',
            shipper_address_locality: 'PINEVILLE',
            shipper_address_region: 'NC',
            shipper_address_postal_code: '28134',
            shipper_address_country: 'UNITED STATES',
            intermodal_contact_uuid: "4a8b8b58-f5ff-4a8d-a408-9c3cbbdc5c7c",
            intermodal_address_uuid: "32f0b94f-e0c3-4f7c-977b-2a34b9ec2aaf",
            intermodal_address: "10627 NATIONS FORD ROAD",
            intermodal_address_line_two: '',
            intermodal_city: 'PINEVILLE',
            intermodal_state_province_code: 'NC',
            intermodal_postal_code: '28134',
            intermodal_country_code: 'UNITED STATES'            
          });
        }
        else if (selectedOption === 'NFI (Chino)') 
        {
          this.contactForm.patchValue({
            shipper_contact_uuid: "a980a12f-743e-419c-8e3c-676e64305a47",
            shipper_address_uuid: "c59886e1-44f3-4986-ad5a-85ce1d54cb8a",
            shipper_company_name: 'NFI (Chino)',
            shipper_address_street: "14701 YORBA AVENUE",
            shipper_address_extended: '',
            shipper_address_locality: 'CHINO',
            shipper_address_region: 'CA',
            shipper_address_postal_code: '91710',
            shipper_address_country: 'UNITED STATES',
            intermodal_contact_uuid: "a980a12f-743e-419c-8e3c-676e64305a47",
            intermodal_address_uuid: "c59886e1-44f3-4986-ad5a-85ce1d54cb8a",
            intermodal_address: "14701 YORBA AVENUE",
            intermodal_address_line_two: '',
            intermodal_city: 'CHINO',
            intermodal_state_province_code: 'CA',
            intermodal_postal_code: '91710',
            intermodal_country_code: 'UNITED STATES'            
          });
        }
        else if (selectedOption === 'NFI - ONTARIO SITE') 
        {
          this.contactForm.patchValue({
            shipper_contact_uuid: "10865029-e760-477a-bc14-94b9328f079d",
            shipper_address_uuid: "9573c302-9d3c-49e6-8f3f-708fef7b7c45",
            shipper_company_name: 'NFI - ONTARIO SITE',
            shipper_address_street: "4061 EAST FRANCIS STREET",
            shipper_address_extended: '',
            shipper_address_locality: 'ONTARIO',
            shipper_address_region: 'CA',
            shipper_address_postal_code: '91761',
            shipper_address_country: 'UNITED STATES',
            intermodal_contact_uuid: "10865029-e760-477a-bc14-94b9328f079d",
            intermodal_address_uuid: "9573c302-9d3c-49e6-8f3f-708fef7b7c45",
            intermodal_address: "4061 EAST FRANCIS STREET",
            intermodal_address_line_two: '',
            intermodal_city: 'ONTARIO',
            intermodal_state_province_code: 'CA',
            intermodal_postal_code: '91761',
            intermodal_country_code: 'UNITED STATES'            
          });
        }      
        else if (selectedOption === "WAINRIGHT TRUCKING LIMITED") 
        {
          this.contactForm.patchValue({
            shipper_contact_uuid: '8f83895e-f813-4d7e-b03d-904508e3e3ad',
            shipper_address_uuid: 'd59bc14f-004f-4bc8-a896-86a6f65556ff',
            shipper_company_name: "WAINRIGHT TRUCKING LIMITED",
            shipper_address_street: "420 INDUSTRIAL ROAD UNIT# 2",
            shipper_address_extended: '',
            shipper_address_locality: 'LONDON',
            shipper_address_region: 'ON',
            shipper_address_postal_code: 'N5V 1T4',
            shipper_address_country: 'CANADA',
            intermodal_contact_uuid: '8f83895e-f813-4d7e-b03d-904508e3e3ad',
            intermodal_address_uuid: 'd59bc14f-004f-4bc8-a896-86a6f65556ff',
            intermodal_address: "420 INDUSTRIAL ROAD UNIT# 2",
            intermodal_address_line_two: '',
            intermodal_city: 'LONDON',
            intermodal_state_province_code: 'ON',
            intermodal_postal_code: 'N5V 1T4',
            intermodal_country_code: 'CANADA'
          });
        }
        else if (selectedOption === "GAP CANADA (SITE GA7)") 
        {
          this.contactForm.patchValue({
            shipper_contact_uuid: 'd9b23c14-069a-4eb6-972f-8ff9c498bb20',
            shipper_address_uuid: 'ebc0992c-2db7-4afc-80cc-0c3e40248277',
            shipper_company_name: "GAP CANADA (SITE GA7)",
            shipper_address_street: "2190 Scanlan St",
            shipper_address_extended: '',
            shipper_address_locality: 'LONDON',
            shipper_address_region: 'ON',
            shipper_address_postal_code: 'N5W 6G8',
            shipper_address_country: 'CANADA',
            intermodal_contact_uuid: 'd9b23c14-069a-4eb6-972f-8ff9c498bb20',
            intermodal_address_uuid: 'ebc0992c-2db7-4afc-80cc-0c3e40248277',
            intermodal_address: "2190 Scanlan St",
            intermodal_address_line_two: '',
            intermodal_city: 'LONDON',
            intermodal_state_province_code: 'ON',
            intermodal_postal_code: 'N5W 6G8',
            intermodal_country_code: 'CANADA'
          });
        }            
        else if (selectedOption === "DSR - DELTA")
        {
          this.contactForm.patchValue({
            shipper_contact_uuid: 'e0cabf6c-746f-403a-9af8-d5dfd630d8a5',
            shipper_address_uuid: '46add129-07d1-40d5-a56c-48910488a0cb',
            shipper_company_name: 'DSR - DELTA',
            shipper_address_street: '109 - 7717 BEEDIE WAY',
            shipper_address_extended: '',
            shipper_address_locality: 'DELTA',
            shipper_address_region: 'BC',
            shipper_address_postal_code: 'V4G 1M1',
            shipper_address_country: 'CANADA',
            intermodal_contact_uuid: '331cc460-bc80-4181-8f0e-05c072641f00',
            intermodal_address_uuid: '8dc09fbf-93c2-45ad-a955-d2acc9f4c044',
            intermodal_address: '109 - 7717 BEEDIE WAY',
            intermodal_address_line_two: '',
            intermodal_city: 'DELTA',
            intermodal_state_province_code: 'BC',
            intermodal_postal_code: 'V4G 1M1',
            intermodal_country_code: 'CANADA',
            carrier_contact_uuid: '0e61ea6f-0b3f-4c4d-a631-2e7a91fbc8bf',
            carrier_company_name: 'DSR LOGISTICS INC',
            carrier_address_uuid: '67e7700e-2ba9-46d2-8ebe-ba4148daf8a8',
            carrier_address_street: '#109-7717 BEEDIE WAY',
            carrier_address_line_two: '',
            carrier_address_locality: 'DELTA',
            carrier_address_region: 'BC',
            carrier_address_postal_code: 'V4G 0A5',
            carrier_address_country: 'CANADA',
            intermodal_carrier_contact_uuid: '0e61ea6f-0b3f-4c4d-a631-2e7a91fbc8bf',
            intermodal_carrier_company_name: 'DSR LOGISTICS INC',
            intermodal_carrier_address_street: '#109-7717 BEEDIE WAY',
            intermodal_carrier_address_line_two: '',
            intermodal_carrier_address_locality: 'DELTA',
            intermodal_carrier_address_region: 'BC',
            intermodal_carrier_address_postal_code: 'V4G 0A5',
            intermodal_carrier_address_country: 'CANADA'
          });
        }
        else if (selectedOption === "DSR Terminal") 
        {
          this.contactForm.patchValue({
            shipper_contact_uuid: "4523aeef-6e85-4d0d-b221-44b4ccdddcb8",
            shipper_address_uuid: "70f9442b-3684-4826-a212-7d0cfbe47604",
            shipper_company_name: 'DSR Terminal',
            shipper_address_street: "109-292164 WAGON WHEEL BLVD",
            shipper_address_extended: '',
            shipper_address_locality: 'ROCKY VIEW COUNTY',
            shipper_address_region: 'AB',
            shipper_address_postal_code: 'T4A 0T5',
            shipper_address_country: 'CANADA',
            intermodal_contact_uuid: "4523aeef-6e85-4d0d-b221-44b4ccdddcb8",
            intermodal_address_uuid: "70f9442b-3684-4826-a212-7d0cfbe47604",
            intermodal_address: "109-292164 WAGON WHEEL BLVD",
            intermodal_address_line_two: '',
            intermodal_city: 'ROCKY VIEW COUNTY',
            intermodal_state_province_code: 'AB',
            intermodal_postal_code: 'T4A 0T5',
            intermodal_country_code: 'CANADA'            
          });
        }   
        else if (selectedOption === "GVN TRANSPORT LTD") 
        {
          this.contactForm.patchValue({
            shipper_contact_uuid: "0d40741d-eabb-449c-b047-80df502dc900",
            shipper_address_uuid: "f144e940-5a35-4eff-bb14-50e881adb46f",
            shipper_company_name: 'GVN TRANSPORT LTD',
            shipper_address_street: "3927 BRODSKY AVE",
            shipper_address_extended: '',
            shipper_address_locality: 'SASKATOON',
            shipper_address_region: 'SK',
            shipper_address_postal_code: 'S79 0C9',
            shipper_address_country: 'CANADA',
            intermodal_contact_uuid: "0d40741d-eabb-449c-b047-80df502dc900",
            intermodal_address_uuid: "f144e940-5a35-4eff-bb14-50e881adb46f",
            intermodal_address: "3927 BRODSKY AVE",
            intermodal_address_line_two: '',
            intermodal_city: 'SASKATOON',
            intermodal_state_province_code: 'SK',
            intermodal_postal_code: 'S79 0C9',
            intermodal_country_code: 'CANADA'            
          });
        }   
        else if (selectedOption === "WINNIPEG CROSSDOCK & LOGISTICS INC") 
        {
          this.contactForm.patchValue({
            shipper_contact_uuid: "817009ae-a00e-4a83-b38b-62767abe4a1d",
            shipper_address_uuid: "932a43a0-0f17-4694-8bd5-bfa3c818bfe0",
            shipper_company_name: 'WINNIPEG CROSSDOCK & LOGISTICS INC',
            shipper_address_street: "12 VERVAIN DRIVE",
            shipper_address_extended: '',
            shipper_address_locality: 'WINNIPEG',
            shipper_address_region: 'MB',
            shipper_address_postal_code: 'R2V 0M1',
            shipper_address_country: 'CANADA',
            intermodal_contact_uuid: "817009ae-a00e-4a83-b38b-62767abe4a1d",
            intermodal_address_uuid: "932a43a0-0f17-4694-8bd5-bfa3c818bfe0",
            intermodal_address: "12 VERVAIN DRIVE",
            intermodal_address_line_two: '',
            intermodal_city: 'WINNIPEG',
            intermodal_state_province_code: 'MB',
            intermodal_postal_code: 'R2V 0M1',
            intermodal_country_code: 'CANADA'
          });
        }   
        else if (selectedOption === "LEO GREEN LOGISTICS") 
        {
          this.contactForm.patchValue({
            shipper_contact_uuid: "13e96812-85cf-46df-8562-69f2eb4b39ee",
            shipper_address_uuid: "6fd2ab38-bf40-4036-8396-b39ddcbc6766",
            shipper_company_name: 'LEO GREEN LOGISTICS',
            shipper_address_street: "5805 98 ST NW DOCK 24",
            shipper_address_extended: '',
            shipper_address_locality: 'EDMONTON',
            shipper_address_region: 'AB',
            shipper_address_postal_code: 'T6E 3L4',
            shipper_address_country: 'CANADA',
            intermodal_contact_uuid: "13e96812-85cf-46df-8562-69f2eb4b39ee",
            intermodal_address_uuid: "6fd2ab38-bf40-4036-8396-b39ddcbc6766",
            intermodal_address: "5805 98 ST NW DOCK 24",
            intermodal_address_line_two: '',
            intermodal_city: 'EDMONTON',
            intermodal_state_province_code: 'AB',
            intermodal_postal_code: 'T6E 3L4',
            intermodal_country_code: 'CANADA'
          });
        }                   

      });


      this.loadDetailsForm = this.formBuilder.group({

        bill_of_lading: [this.shipment_details.details.external_bill_of_lading, Validators.required],
        asn_number: [this.shipment_details.details.asn_number, Validators.required],
        trip_number: [this.shipment_details.details.trip_number, Validators.required],
        shipment_number: [''],
        booking_number: [''],
        load_details: ['', Validators.required],
        load_special_info: ['', Validators.required],
        load_weight: [this.shipment_details.details.reported_weight, Validators.required],
        load_actual_weight: ['', Validators.required],
        load_length: [this.pallets.length * 2, Validators.required],
        load_pieces: [this.calcTotalCartons(), Validators.required],
        load_pallets: [this.pallets.length, Validators.required],
        load_value: ['', Validators.required],
        container: ['']

      })

      // primary delivery load form
      this.appointmentForm = this.formBuilder.group({

        appointment_date_pickup: ['', Validators.required],
        appointment_time_start_pickup: ['', Validators.required],
        appointment_time_end_pickup: ['', Validators.required],
        intermodal_date_pickup: ['', Validators.required],
        intermodal_time_start_pickup: ['', Validators.required],
        intermodal_time_end_pickup: ['', Validators.required],        
        primary_on_site_first_name_01: [this.shipment_details.consignee.contact_name_given],
        primary_on_site_last_name_01: [this.shipment_details.consignee.contact_name_family],
        ConsigneeContactDate: [''],
        pro_bill_01: [this.pro_bill, Validators.required],
        appointment_date_delivery_01: ['', Validators.required],
        appointment_time_start_delivery_01: [this.formatTime(this.shipment_details.operation.appointment_start)],
        appointment_time_end_delivery_01: [this.formatTime(this.shipment_details.operation.appointment_end)],
        appointment_date_01: ['', Validators.required],
        appointment_time_start_01: [this.formatTime(this.shipment_details.operation.appointment_end)],
        appointment_time_end_01: [this.formatTime(this.shipment_details.operation.appointment_end)],

      })

      // if delivery split into 2 loads, form for 2nd load
      this.deliveryLoad02Form = this.formBuilder.group({

        primary_on_site_first_name_02: [this.shipment_details.consignee.contact_name_given],
        primary_on_site_last_name_02: [this.shipment_details.consignee.contact_name_family],
        pro_bill_02: [this.pro_bill, Validators.required],
        appointment_date_delivery_02: ['', Validators.required],
        appointment_time_start_delivery_02: [this.formatTime(this.shipment_details.operation.appointment_start)],
        appointment_time_end_delivery_02: [this.formatTime(this.shipment_details.operation.appointment_end)],
        appointment_date_02: ['', Validators.required],
        appointment_time_start_02: [this.formatTime(this.shipment_details.operation.appointment_start)],
        appointment_time_end_02: [this.formatTime(this.shipment_details.operation.appointment_end)],
      })

      // if delivery split into 3 loads, form for 3rd load
      this.deliveryLoad03Form = this.formBuilder.group({

        primary_on_site_first_name_03: [this.shipment_details.consignee.contact_name_given],
        primary_on_site_last_name_03: [this.shipment_details.consignee.contact_name_family],
        pro_bill_03: [this.pro_bill, Validators.required],
        appointment_date_delivery_03: ['', Validators.required],
        appointment_time_start_delivery_03: [this.formatTime(this.shipment_details.operation.appointment_start)],
        appointment_time_end_delivery_03: [this.formatTime(this.shipment_details.operation.appointment_end)],
        appointment_date_03: ['', Validators.required],
        appointment_time_start_03: [this.formatTime(this.shipment_details.operation.appointment_start)],
        appointment_time_end_03: [this.formatTime(this.shipment_details.operation.appointment_end)],
      })

      // update variable to display the wizard's content to the modal
      this.showContent = true

      // determine which customer (Spencer Gifts or Spirit Halloween) is based on store number
      let first_store_digit = this.store_number.charAt(0)

      // if store number starts with 6 or more, pre-populate with SPIRIT HALLOWEEN details
      if (parseInt(first_store_digit) >= 6) {

        this.contactForm.patchValue({
          customer_contact_uuid: 'af6d9b51-2ca1-4496-b99d-28a949274d2d',
          customer_address_uuid: 'd3979465-b994-4f6a-8192-a4be9b7199e2',
          customer_company_name: 'SPIRIT HALLOWEEN',
          customer_address: '11025 CAROLINA PLACE PARKWAY #D2',
          customer_city: 'PINEVILLE',
          customer_region: 'NC',
          customer_country_code: 'UNITED STATES',
          customer_postal_code: '28134',
        });

        // if store number less than 6 then pre-populate with SPENCER GIFTS details
      } else {

        this.contactForm.patchValue({
          customer_contact_uuid: '84668f0d-3507-4746-b11e-1b0d25ce5845',
          customer_address_uuid: 'fa2c7894-08d6-4033-b882-2c095608a621',
          customer_company_name: 'SPENCER GIFTS',
          customer_address: '11025 CAROLINA PLACE PARKWAY #D2',
          customer_city: 'PINEVILLE',
          customer_region: 'NC',
          customer_country_code: 'UNITED STATES',
          customer_postal_code: '28134',
        });

      }
    }
  }

  // format time values to format XX:XX
  formatTime(time: string) {
    if (time != null)
    {
      const timeSplit = time.split(':')
      return `${timeSplit[0]}:${timeSplit[1]}`
    }
    return null;
  }

  // calculate total number of load pieces
  calcTotalCartons() {
    let totalCartons = 0

    this.pallets.forEach(pallet => {
      totalCartons += Number(pallet.cartons_pallet)
    })

    return totalCartons.toString()
  }

  // Method to toggle the intermodal leg
  toggleIntermodalLeg() {
    this.creationError = '';
    this.addIntermodalLeg = !this.addIntermodalLeg;
    if (this.addIntermodalLeg) {
      this.shipperBeforeIntermodal = Object.fromEntries(
        Object.entries(this.contactForm.value).filter(([key]) => key.startsWith('shipper_'))
      );
    } else {
      this.contactForm.patchValue({
        ...(this.shipperBeforeIntermodal || {}),
        intermodal_company_name: '', intermodal_contact_uuid: '', intermodal_address_uuid: '',
        intermodal_address: '', intermodal_address_line_two: '', intermodal_city: '',
        intermodal_state_province_code: '', intermodal_postal_code: '', intermodal_country_code: ''
      }, { emitEvent: false });
      this.shipperBeforeIntermodal = null;
    }
  }

  // Proceed to the next step in the form
  nextStep() {
    if (this.step < this.totalSteps) {
      this.step++;
    }
  }

  // Move back to the previous step in the form
  prevStep() {
    if (this.step > 1) {
      this.step--;
    }
  }
  isLoading: boolean = false;
  showCreationError(message: string): void {
    this.creationError = message;
    window.alert(message);
  }

  submit() {
    if (this.isReconcilingAddress || this.isLoading) return;
    this.creationError = '';
    const formData = { ...this.contactForm.value, intermodal_enabled: this.addIntermodalLeg };
    if (!this.pendingCreationRequest && this.addIntermodalLeg) {
      const required = ['intermodal_contact_uuid', 'intermodal_address_uuid',
        'shipper_contact_uuid', 'shipper_address_uuid', 'carrier_contact_uuid',
        'intermodal_carrier_contact_uuid'];
      if (required.some(key => !formData[key])) {
        this.showCreationError('Select a complete intermodal terminal and carriers before creating the order.');
        return;
      }
      if (formData.intermodal_company_name === 'DSR - DELTA' &&
          (formData.shipper_contact_uuid !== 'e0cabf6c-746f-403a-9af8-d5dfd630d8a5' ||
           formData.carrier_contact_uuid !== '0e61ea6f-0b3f-4c4d-a631-2e7a91fbc8bf' ||
           formData.intermodal_carrier_contact_uuid !== '0e61ea6f-0b3f-4c4d-a631-2e7a91fbc8bf')) {
        this.showCreationError('Re-select DSR - DELTA and use DSR LOGISTICS INC as the carrier for both legs.');
        return;
      }
    } else {
      formData.intermodal_company_name = '';
      formData.intermodal_contact_uuid = '';
      formData.intermodal_address_uuid = '';
    }
    formData.loadDetailsForm = this.loadDetailsForm.value;
    formData.appointmentForm = this.appointmentForm.value;
    formData.deliveryLoad02Form = this.deliveryLoad02Form.value;
    formData.deliveryLoad03Form = this.deliveryLoad03Form.value;
    this.isLoading = true;
    const request = this.pendingCreationRequest ?? formData;
    this.http.post<any>('/api/shipment_lists/shipment_create_work_order.php', request)
      .subscribe({
        next: response => {
          this.isLoading = false;
          if (response?.message !== 'OK') {
            this.setCreationPending(response?.message === 'Pending' ? request : null);
            this.showCreationError(response?.result || 'Creation was not confirmed. Check this shipment before retrying.');
            return;
          }
          this.dialog.closeAll();
          window.location.reload();
        },
        error: error => {
          this.isLoading = false;
          this.setCreationPending(error?.status === 0 || error?.status >= 500 || error?.error?.operation_uuid ? request : null);
          this.showCreationError(error?.error?.result || 'Creation was not confirmed. Check this shipment before retrying.');
        }
      });
  }

  private setCreationPending(request: any): void {
    this.pendingCreationRequest = request;
    for (const form of [this.contactForm, this.loadDetailsForm, this.appointmentForm,
      this.deliveryLoad02Form, this.deliveryLoad03Form]) {
      if (request) form.disable({ emitEvent: false });
      else form.enable({ emitEvent: false });
    }
  }

  // Change step to the step relative to the icon on the progress bar clicked on
  changeStep(newStep: number) {
    this.step = newStep;
  }

}
